/**
 * SWORD API
 * SWORD service API to be consumed by SWORD Angular SPA. Interfaces with Entra ID and DataBricks.
 *
 * OpenAPI spec version: v1
 * Contact: donnie.hyatt@tnedu.gov
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Class assignments
 */
export interface StudentClassAssignment { 
    /**
     * Assignment begin date
     */
    assignmentBeginDate?: string;
    /**
     * Assignment end date
     */
    assignmentEndDate?: string;
    /**
     * Class begin date
     */
    classBeginDate?: string;
    /**
     * Class end date
     */
    classEndDate?: string;
    /**
     * Class period duration
     */
    classPeriodDuration?: number;
    /**
     * Class period meeting days
     */
    classPeriodMeetingDays?: string;
    /**
     * Class period name
     */
    classPeriodName?: string;
    /**
     * Class type
     */
    classType?: string;
    /**
     * Course code
     */
    courseCode?: string;
    enrollmentClassification?: string;
    /**
     * Enrollment period begin date
     */
    enrollmentPeriodBeginDate?: string;
    /**
     * Enrollment period end date
     */
    enrollmentPeriodEndDate?: string;
    /**
     * Local class number
     */
    localClassNumber?: string;
    tos?: string;
}
